import { render } from "./labos_create_modal.vue?vue&type=template&id=67ace91c"
import script from "./labos_create_modal.vue?vue&type=script&lang=js"
export * from "./labos_create_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__